<template>
	<div>
		<video @click="goIndex" style="width:100%;height:100%" object-fit="fill"
			src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1700711015035.mp4" autoplay loop></video>
	</div>
</template>

<script>
	export default {
		name: 'app',
		components: {},
		data() {
			return {
				testSetinterval: null
			};
		},
		mounted() {
			this.testSetinterval = setInterval(() => {
				setTimeout(() => {
					this.$router.replace('/index');
				}, 0)
			}, 12000)
		},
		beforeDestroy() {
			// 清除这个定时器
			clearInterval(this.testSetinterval)
		},
		methods: {
			goIndex() {
				this.$router.replace('/index');
			}
		}

	};
</script>

<style></style>